document.addEventListener('click', function (e) {
  const openTrigger = e.target.closest('[data-bonsai-search="open"]');
  const closeTrigger = e.target.closest('[data-bonsai-search="close"]');

  // OPEN (toggle)
  if (openTrigger) {
    e.preventDefault();

    if (document.body.classList.contains('bonsai-search-enabled')) {
      document.body.classList.remove('bonsai-search-enabled');
    } else {
      document.body.classList.add('bonsai-search-enabled');
    }
    return;
  }

  // CLOSE
  if (closeTrigger) {
    e.preventDefault();
    document.body.classList.remove('bonsai-search-enabled');
  }
});

// ESC key handling
document.addEventListener('keydown', function (e) {
  if (
    e.key === 'Escape' &&
    document.body.classList.contains('bonsai-search-enabled')
  ) {
    document.body.classList.remove('bonsai-search-enabled');
  }
});